<div class="ssc-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="ssc-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="ssc-shell__sidebar"
    [class.ssc-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.ssc-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="ssc-main">
    <app-dashboard-header
      [title]="title"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <section class="ssc-content">
      <ng-content></ng-content>
    </section>
  </div>
</div>
